import { lazy } from "react";

const CartVTEX = lazy(() => import("./vtex/Cart"));

export interface Props {
  freeShippingTarget?: number;
}

function Cart({ freeShippingTarget }: Props) {
  return <CartVTEX freeShippingTarget={freeShippingTarget} />;
}

export default Cart;
